var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded-lg shadow hover:shadow-lg hover:cursor-pointer mb-6 "},[_c('router-link',{staticClass:"w-full cursor-pointer no-underline hover:no-underline",attrs:{"to":{ name: 'survey-builder', params: { surveyid: _vm.survey.id } }}},[_c('div',{staticClass:"h-36 flex flex-row justify-center items-center"},[_c('p',{staticClass:"px-4 pt-4 pb-6 text-gray-600 text-base font-bold my-auto"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])]),_c('hr'),_c('div',{staticClass:"flex flex-row justify-between p-4"},[_c('router-link',{staticClass:"text-xs hover:no-underline hover:text-gray-600 cursor-pointer font-semibold inline-block py-1 px-2 uppercase rounded text-gray-600 bg-purple-200 uppercase last:mr-0 mr-1",attrs:{"to":{ path: '/results/' + _vm.survey.id }},domProps:{"textContent":_vm._s(_vm.responseCount + ' responses')}}),_c('BaseDropDown',{attrs:{"items":[
        {
          label: 'Edit survey',
          route: { path: '/builder/' + _vm.survey.id },
          icon: 'heroicons/outline/pencil-alt',
        },
        {
          label: 'Clone survey',
          event: 'clone-survey',
          args: _vm.survey.id,
          icon: 'heroicons/outline/duplicate',
        },
        {
          label: 'Delete survey',
          event: 'confirm-delete',
          args: _vm.survey.id,
          icon: 'heroicons/outline/x-circle',
        },
        {
          label: 'Survey results',
          route: { path: '/results/' + _vm.survey.id },
          icon: 'heroicons/outline/chart-square-bar',
        },
        {
          label: 'Install Code',
          route: { path: '/settings/' + _vm.survey.id },
          icon: 'heroicons/outline/cog',
        } ]},on:{"clone-survey":function($event){return _vm.$emit('clone-survey', _vm.survey.id)},"confirm-delete":function($event){return _vm.$emit('confirm-delete', _vm.survey.id)}},scopedSlots:_vm._u([{key:"button",fn:function(){return [_c('div',{staticClass:"items-center flex"},[_c('span',{staticClass:"mr-4 text-gray-400 hover:text-gray-500 hover:bg-gray-200 inline-flex items-center justify-center rounded"},[_c('svg-icon',{staticClass:"h-6 w-6 text-gray-600",attrs:{"icon":"heroicons/outline/dots-horizontal"}})],1)])]},proxy:true}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }